import service from '@/services/booking/booking'

const getDefaultState = () => ({
  plan: {
    name: '',
    observation: '',
    state: '', // creado ??
    percentage: '',
    session: [],
    product: [],
    totalPlan: 0
  },
  list: [],
  saved: false
})

export const state = () => getDefaultState()

export const mutations = {
  // SET: (state, obj) => {
  //   state.plan = obj
  // },
  // RESET_STATE: state => {
  //   state.plan = { ...getDefaultState().plan }
  // },
  // SAVE_CHANGES: (state, obj) => {
  //   state.plan = obj
  //   state.saved = false
  // }
  SET_LIST: (state, response) => {
    state.list = response
  }
}
export const actions = {
  readByEmisor: async ({ rootGetters, commit }) => {
    return service.readByEmisor(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      commit('SET_LIST', response)

      return response
    })
  }
}
